<template>
    <div id="cinema-manage">
      <!--表格-->
      <div class="cinema-table">
        <el-table
          border
          :data="tableData"
          >
          <el-table-column
            label="套餐ID"
            align="center"
            width="70"
            prop="combId">
          </el-table-column>
          <el-table-column
            label="套餐名称"
            width="220"
            align="center"
            prop="productDesc">
          </el-table-column>
          <el-table-column
            label="套餐价格"
            align="center"
            width="120"
            prop="price">
          </el-table-column>
          <el-table-column
            label="赠送时长"
            align="center"
            prop="originPrice">
          </el-table-column>
          <el-table-column label="编辑" align="center" width="110">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">修改套餐价格</el-button>
          </template>
        </el-table-column>
      

        </el-table>
      </div>
      <!--分页-->
      <div class="block" v-if="tableData.length">
        <el-pagination
          @current-change="currentChange"
          background
          layout="prev, pager, next"
          :page-size="8"
          :page-count="total">
        </el-pagination>
      </div>
      <!--弹框-->
      <div>
        <el-dialog
          :title="dialogTitle"
          :visible.sync="dialogFormVisible"
          :modal-append-to-body="false"
          v-if="dialogFormVisible"
          :showClose="false"
        >
          <el-form :label-position="labelPosition" label-width="80px" :model="cinemaInfo">
            <el-form-item label="套餐名称" prop="productDesc">
              <el-col :span="18">
                <el-input v-model="cinemaInfo.productDesc"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="套餐价格" prop="price">
              <el-col :span="18">
                <el-input v-model="cinemaInfo.price"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="赠送时长" prop="gift">
              <el-col :span="18">
                <el-input v-model="cinemaInfo.gift"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="时长单位" prop="gift_m">
              <el-select v-model="cinemaInfo.gift_m" placeholder="请选择单位">
                <el-option label="天" value="天"></el-option>
                <el-option label="月" value="月"></el-option>

              </el-select>
            </el-form-item>
            

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="manageCinemaInfo()">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
</template>

<script>
    import {MessageBox,Message} from 'element-ui'
    import {getCurrentPageCinema,updateCinemaInfo,deleteCinemaInfo,getBrandList,addCinemaBrand} from '../../../api'
    import Vue from "vue"
    import axios from 'axios';
    export default {
        name: "CinemaManage",
        data() {
          return {
            tableData:[],
            uploadUrl:"http://120.26.124.66/api/mg/upload",
            total:0,
            currentPage:1,
            cinemaInfo:{},
            brandList:[],
            dialogFormVisible:false,
            dialogTitle:'',
            newBrand:'',
            addBrandId: '',
            labelPosition:'right',
            input:'',
            searchInput:'',
            id:'',
            name:'',
            version:'',
            url:'',
            update_at:''
          }
        },
        created(){
          this.loadCurrentPageCinema(this.currentPage,8,'');
        },
        methods: {



          async loadCurrentPageCinema(currentPage,pageSize,input){
            let json = await getCurrentPageCinema(currentPage,pageSize,input);
            if (json.code===200){
              this.tableData = json.result;
              this.total = 1;
            }
          },
          async loadBrandList(){
            let json = await getBrandList();
            if (json.state===200){
              this.brandList = json.data;
            }
          },

          formatBoolean: function (row, column, cellValue) {
            var ret = ''  //你想在页面展示的值
            if (cellValue) {
              ret = "支持"  //根据自己的需求设定
            } else {
              ret = "不支持"
            }
            return ret;
          },
          handleEdit(index, row) {
            this.cinemaInfo = row;
            this.dialogTitle = '编辑套餐信息';
            // this.cinemaInfo.id= row.combId;
            // this.cinemaInfo.shop= row.productDesc;
            // this.cinemaInfo.price= row.price;
            // this.cinemaInfo.gift= row.gift;
            // this.cinemaInfo.gift_m= row.gift_m;
            // console.log(this.cinemaInfo)
            this.dialogFormVisible = true;
            this.newBrand = '';
          },

          handleDelete(index, row) {
            console.log(index, row);
            MessageBox.confirm('此操作将永久删除该版本所有信息, 是否继续？','提示').then(async (value)=>{
              if (value==='confirm'){
                let json = await deleteCinemaInfo(row.id);
                if (json.code==='200'){
                  Message.success(json.msg);
                  this.loadCurrentPageCinema(this.currentPage,8,this.searchInput);
                }
              }
            });
            console.log(index, row);
          },
          selectBlur(e){
            this.cinemaInfo.brandId = e.target.value;
            this.newBrand = e.target.value;
            this.addBrandId = e.target.value;
          },
          //修改影院信息
          async manageCinemaInfo(){
            
            if (this.dialogTitle==='编辑版本信息'){
              this.cinemaInfo.ctype =2
            }
            let json = await addCinemaBrand(this.cinemaInfo);
            if (json.code===200){
                Message.success(json.msg);


              } else{
                Message.error(json.msg);
              }
            this.cancel();

            
          },
          async currentChange(currentPage){
            this.currentPage = currentPage;
            this.loadCurrentPageCinema(this.currentPage,8,this.searchInput);
          },
          //搜索影院
          search(){
            this.searchInput = this.input;
            this.loadCurrentPageCinema(1,8,this.searchInput);
          },
          //添加影院
          addCinema(){
            this.loadBrandList();
            this.dialogTitle = '添加版本';
            this.cinemaInfo = {};
            this.newBrand = '';
            this.dialogFormVisible = true;
          },
          cancel(){
            this.loadCurrentPageCinema(this.currentPage,8,this.searchInput);
            this.dialogFormVisible = false;
          },
          httpRequest(op) {
              const formData = new FormData();
              formData.append('file', op.file);
              formData.append('id', op.data.id);

              axios.post('http://120.26.124.66/api/mg/upload', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(response => {
                let json  = response.data; // 从响应中获取数据;
                if (json.code==='200'){
                    Message.success(json.msg)
                  this.loadCurrentPageCinema(1,10,'');
                  }
              })
              .catch(error => {
                // 处理上传失败的逻辑
                 Message.error('上传失败，请重试')
              });

            },


        },
    }
</script>

<style>
  .cinema-table{
    width:90%;
    min-width:900px;
    margin: 0 auto;
    margin-bottom: 30px;
  }
  .top{
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 30px 0; */
    margin-bottom: 30px;
  }
  .block{
    text-align: center;
  }
  .el-dialog__header{
    text-align: center;
  }
  .el-dialog__body .el-form-item{
    width: 80%;
    padding-left: 20%;
  }

  .opera-img {
  color: #00BFFF; /* 设置蔚蓝色，可以根据需要调整颜色值 */
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/children/CinemaManage.vue